import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";

const laadpaalArnhemData = {
  service: 'laadpaal',
  serviceName: 'Laadpaal',
  location: 'arnhem',
  locationName: 'Arnhem',
  title: 'Laadpaal Arnhem | Thuis Laadstation Installatie | SOL-VI',
  description: '🚗 Laadpaal installatie in Arnhem ⚡ Erkend installateur 🏠 Slimme laadoplossingen ✅ Gratis advies en offerte. Bel: 06-55331870',
  keywords: 'laadpaal arnhem, laadpaal installatie arnhem, thuis laadstation arnhem, elektrische auto laden arnhem',
  heroText: 'Slimme laadpaal voor thuis in Arnhem. Erkend installateur met ervaring in elektrische laadstations. Gratis advies en snelle installatie.',
  mapUrl: 'https://3dbag.nl/nl/viewer?rdx=190793.96101943016&rdy=443442.57222759165&ox=362.46657840622356&oy=656.6424872608835&oz=570.7321354615706',
  features: [
    {
      title: 'Kostenbesparing',
      description: 'Laden thuis is tot 50% goedkoper dan openbaar laden',
      content: 'Met thuistarieven bespaart u flink op laadkosten vergeleken met publieke laadpalen.'
    },
    {
      title: 'Gemak & Comfort',
      description: 'Start elke dag met een volledig opgeladen auto',
      content: 'Geen zoeken naar vrije laadpalen - uw auto laadt \'s nachts op terwijl u slaapt.'
    },
    {
      title: 'Slimme Functies',
      description: 'App bediening, timers en energiebeheer',
      content: 'Beheer uw laadsessies via de app en optimaliseer het energieverbruik.'
    }
  ],
  offers: [
    {
      name: 'Standaard Laadpaal 11kW',
      description: 'Slimme laadpaal met app bediening voor thuisgebruik',
      priceRange: '€1.200 - €1.800'
    },
    {
      name: 'Premium Laadpaal 22kW',
      description: 'Snellaadpaal met dynamic load balancing',
      priceRange: '€1.800 - €2.500'
    }
  ],
  projects: [
    {
      area: 'Arnhem-Noord',
      specs: '11kW laadpaal met app bediening',
      testimonial: 'Perfect geïnstalleerd, laden gaat supersnel en app werkt uitstekend!',
      author: 'Familie Hermans'
    },
    {
      area: 'Presikhaaf',
      specs: '22kW laadpaal met zonnepanelen',
      testimonial: 'Geweldige combinatie met zonnepanelen - nu laden we gratis met de zon!',
      author: 'Dhr. van Dijk'
    },
    {
      area: 'Arnhem-Zuid',
      specs: 'Slimme laadpaal met dynamic load balancing',
      testimonial: 'Innovatieve oplossing, voorkomt overbelasting van de meterkast.',
      author: 'Mevr. Bakker'
    }
  ],
  ctaText: 'Klaar voor een Laadpaal in Arnhem?',
  ctaDescription: 'Ontdek welke laadpaal het beste bij uw situatie past. Gratis advies en transparante prijzen.'
};

const LaadpaalArnhem = () => {
  return <LocalServiceTemplate data={laadpaalArnhemData} />;
};

export default LaadpaalArnhem;